import { render, staticRenderFns } from "./RecursosDeGlosaGeral.vue?vue&type=template&id=7a0ed8c4"
import script from "./RecursosDeGlosaGeral.vue?vue&type=script&lang=js"
export * from "./RecursosDeGlosaGeral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports